import { TypedDocumentNode } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import { ReceptionStatusManagerAdminBaseQueryDocument } from '@docpace/reception-status-graphql/dist/urql.types'
import { ReceptionStatusManagerAdminBaseQueryResultFragment } from '@docpace/reception-status-graphql'

const typedReceptionStatusManagerAdminBaseQueryDocument = ReceptionStatusManagerAdminBaseQueryDocument as TypedDocumentNode<ReceptionStatusManagerAdminBaseQueryResultFragment>

export function useReceptionStatusManagerAdminBaseQuery(opts?: useQuery.Options<ReceptionStatusManagerAdminBaseQueryResultFragment>){
    return useQuery(typedReceptionStatusManagerAdminBaseQueryDocument, opts)
}
